import { render, staticRenderFns } from "./CVPartsTable.vue?vue&type=template&id=ad52af08&"
import script from "./CVPartsTable.vue?vue&type=script&lang=js&"
export * from "./CVPartsTable.vue?vue&type=script&lang=js&"
import style0 from "./CVPartsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
